import PropTypes, { oneOfType } from 'prop-types';
import { classes } from '@/helpers/styling';
import Text from '@/components/component-library/Text';

const Stat = ({
  title,
  value,
  centered,
  alignedRight,
  loading,
  fullWidth
}) => (
  <div
    className={ classes({
      'stat': true,
      '--is-aligned-right': alignedRight,
      '--is-aligned-center': centered,
      '--is-full-width': fullWidth
    }) }
  >
    <Text
      bold
      className='stat-title'
      loading={ loading } useHeaderFont
    >
      { title }
    </Text>
    <Text
      bold
      className='stat-value'
      loading={ loading } useHeaderFont
    >
      { value }
    </Text>
  </div>
);

Stat.propTypes = {
  title: PropTypes.string.isRequired,
  value: oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  centered: PropTypes.bool,
  alignedRight: PropTypes.bool,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool
};

Stat.defaultProps = {
  centered: false,
  alignedRight: false,
  loading: false,
  fullWidth: false
};

export default Stat;